import React, { Component } from 'react';
import Button from '../Field_Components/Button/Button';
import Staff from '../Field_Components/Staff/Staff';
import {
    Page,
    Content,
    Nav,
    Loading,
    Footer,
    SafeAreaWrap
} from '@beisen/chaos-ui';

import {
    ifHidePopupNav,
    generateHeaderConfig,
    clearHeaderConfig
} from '../util/helper';
import classNames from 'classNames';
import { addEnNavClassName } from '../util/ui';
import transLoader from '@beisen/i18n-translation-loader';

require('./EditForm.scss');
const defaultTranslation = {
    confirm: '确定',
    cancel: '取消',
    required: '必填'
};
class EditOwnerForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            disabled: false
        };
        this.ownerChange = this.ownerChange.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.saveOwnerFormData = this.saveOwnerFormData.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            confirm: 'common.confirm',
            cancel: 'common.cancel',
            required: 'common.required'
        }), props.translation);
    }

    componentDidMount() {
        let params = {};
        params.metaObjName = this.props.popOptions.cmpContext.metaObjName;
        params.viewName = this.props.popOptions.cmpContext.viewName;
        if (this.props.popOptions.data.ids.indexOf(',') < 0) {
            params.id = this.props.popOptions.data.ids;
        }
        this.props.actions.fetchOwnerData(
            this.props.cmp_id,
            this.props.popOptions,
            params
        );

        if (ifHidePopupNav()) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        let title = this.props.popOptions.params.title;
        generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'editOwnFormCancel',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);

            if (title) {
                config.titleItem = {
                    text: title,
                    icon: '',
                    callback: '',
                    control: false
                };
            }
            return config;
        });
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        clearHeaderConfig();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['editOwnFormCancel'] = this.cancelEdit.bind(
            this
        );
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['editOwnFormCancel'];
    }

    cancelEdit(e) {
        e && e.preventDefault && e.preventDefault();
        e && e.persist && e.persist();
        this.props.actions.btnClearFn();
    }

    ownerChange(owner) {
        if (owner.hasOwnProperty('avatars')) {
            delete owner.avatars;
        }
        if (owner) {
            this.setState({ errorMessage: {} });
        }
        this.isChange = true;
        this.owner = owner;
    }

    //按钮置灰
    disableButton() {
        this.setState({ disabled: true });
    }

    saveOwnerFormData(e) {
        const { translation } = this;
        // 如果按钮处于禁用状态,则禁止再次点击
        if (this.state.disabled) {
            return false;
        }
        if (!this.isChange) {
            this.owner =
                this.props.sub_cmps && this.props.sub_cmps.length > 0
                    ? this.props.sub_cmps[0]['biz_data']
                    : null;
        }
        if (!this.owner || (this.owner && !this.owner.value)) {
            this.setState({ errorMessage: { message: translation.required, disabled: false } });
            this.props.actions.showTip({
                message: translation.required
                , type: 'error'
                , isAutomaticCloseTip: true
            });
            return false;
        }
        this.disableButton();
        let subcmps = this.props.tableData
            ? this.props.tableData.sub_cmps
            : null;
        let firstFiledName;
        if (subcmps) {
            for (let i = 0; i < subcmps.length; i++) {
                let sub = subcmps[i];
                if (sub.cmp_data.visible) {
                    firstFiledName = sub.cmp_name;
                    break;
                }
            }
        }

        let keys = [];
        this.props.dataArr.forEach((item, index) => {
            let text = '';
            if (firstFiledName) {
                text =
                    toString.call(item[firstFiledName]) === '[object Object]'
                        ? item[firstFiledName]['text']
                        : item[firstFiledName];
            }
            keys.push({
                ID:
                    toString.call(item['_id']) === '[object Object]'
                        ? item['_id']['value']
                        : item['_id'],
                Text: parseInt(text)
            });
        });
        let params = {};
        params.Keys = keys;
        params.Value = parseInt(this.owner.value);
        let cmpContext = {
            metaObjName: this.props.popOptions.cmpContext.metaObjName
        };
        let nextActions = [this.saveAfter];
        const { postSearchData } = this.props.popOptions.params || {};
        if (postSearchData && postSearchData.trim() === 'true') {
            params = Object.assign(params, this.props.searchData);  // 业务需求：在所有表单保存时追加搜索条件参数
        }
        this.props.actions.updateOwnerData(
            this.props.sub_cmps[0].cmp_id,
            params,
            cmpContext,
            this.owner,
            nextActions,
            this.props.analysisData
        );
    }

    saveAfter = result => {
        let resp = result.data;
        let data = [];
        data.push(resp);

        this.props.actions.btnNextFn({
            resultData: resp,
            selectData: data
        });
    };
    render() {
        const { translation } = this;
        let navStyle = ifHidePopupNav() ? { display: 'none' } : {};
        const owner = this.props.sub_cmps && this.props.sub_cmps.length > 0 ? this.props.sub_cmps[0] : null;
        const ownerBiz = this.owner ? this.owner : (owner ? owner.biz_data : { text: '', value: '' });
        const enNavButtonClass = addEnNavClassName();
        return (
            <Page cls="edit-form">
                <Nav cls="editform-navbar" title={this.props.popOptions.params.title} style={navStyle}>
                    <a role="left" href='javascript:;' className={classNames('editform-cancle-btn', enNavButtonClass)} onTouchTap={this.cancelEdit}>{translation.cancel}</a>
                </Nav>

                <Content>
                    {!owner ? (
                        <Loading />
                    ) : (
                        <Staff
                            label={owner.cmp_label}
                            text={ownerBiz.text}
                            value={ownerBiz.value}
                            required={true}
                            {...owner}
                            errorMessage={this.state.errorMessage}
                            showTip={this.props.actions.showTip}
                            onChange={this.ownerChange}
                        />
                    )}
                </Content>
                <Footer>
                    <SafeAreaWrap safeAreaStyle={{ background: '#f5f6f7' }}>
                        <Button cmp_label={translation.confirm} type="primary" onTouchTap={this.saveOwnerFormData} />
                    </SafeAreaWrap>
                </Footer>
            </Page>
        );
    }
}

export default EditOwnerForm;



// WEBPACK FOOTER //
// ./src/components/Form/EditOwnerForm.js